import React, { useEffect, useState } from "react";
import Select from "react-select";
import { JSON_Bank_Ifcs14 } from "./JSON_DATA_Responseflowone";
import ReactJson from "react-json-view";
import { CopyToClipboard } from "react-copy-to-clipboard";

function ResponseJSONflowfourteen() {
  const [OptionDataRequest, SetOptionDataRequest] = useState([]);
  const [selectedOptionRequest, SetselectedOptionRequest] = useState([]);

  const [CollapseExpandRequest, SetCollapseExpandRequest] = useState(false);
  const [StateForCopyResquest, SetStateForCopyRequest] = useState();

  useEffect(() => {
    const optionsRequest = [{ value: "1", label: "application/json" }];
    SetOptionDataRequest(optionsRequest);

    SetselectedOptionRequest({ value: "1", label: "application/json" });
  }, []);
  useEffect(() => {
    if (selectedOptionRequest.value == 1) {
      SetStateForCopyRequest(JSON.stringify(JSON_Bank_Ifcs14, null, 2));
    } else {
      SetStateForCopyRequest("");
    }
  }, [selectedOptionRequest]);

  const onClickExpandAllRequest = () => {
    SetCollapseExpandRequest(false);
  };
  const onClickCollapseAllRequest = () => {
    SetCollapseExpandRequest(true);
  };

  const funJSON_DATA_Request = () => {
    if (selectedOptionRequest.value == 1) {
      return (
        <pre>
          {/* {JSON.stringify(JSON_ONE, null, 2)} */}
          <ReactJson src={JSON_Bank_Ifcs14} collapsed={CollapseExpandRequest} />
        </pre>
      );
    } else {
      return <div>No Data</div>;
    }
  };
  const onChangeSelectedRequest = (data) => {
    SetCollapseExpandRequest(false);
    SetselectedOptionRequest(data);
  };

  return (
    <>
      {/* <h1 className="apix-sub-heading-2">Failed</h1> */}
      {/* <div class="payload-div">Payload</div> */}
      <div class="div-blk">
        <div class="select-wrap">
          <Select
            value={selectedOptionRequest}
            onChange={onChangeSelectedRequest}
            options={OptionDataRequest}
          />
          <div class="sc-efHYUO dIxbMO">
            <CopyToClipboard text={StateForCopyResquest}>
              <button>Copy</button>
            </CopyToClipboard>
            <button onClick={onClickExpandAllRequest}> Expand all </button>
            <button onClick={onClickCollapseAllRequest}> Collapse all </button>
          </div>
        </div>
        <div class="output">{funJSON_DATA_Request()}</div>
      </div>
    </>
  );
}

export default ResponseJSONflowfourteen;
